import Icon from '../components/Icon.vue'

Icon.register({
  chair: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M446.3 341.9L435.7 309.9A32-32 0 0 1 405.3 288H42.7C28.9 288 16.7 296.8 12.3 309.9L1.7 341.9C-5.2 362.6 10.2 384 32 384H32V496C32 504.8 39.2 512 48 512H80C88.8 512 96 504.8 96 496V384H352V496C352 504.8 359.2 512 368 512H400C408.8 512 416 504.8 416 496V384H416C437.8 384 453.2 362.6 446.3 341.9zM112 128C112 98.5 128.2 73 152 59.1V256H200V48H248V256H296V59.1C319.8 73 336 98.5 336 128V256H384V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256H112V128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chair.js
// module id = SBnL
// module chunks = 144